module.exports = __webpack_public_path__ + "img/mcabee-logo.c77d57a7.jpg";